import { type FC } from 'react'

import {
  productAccessorGetBestSellerPromotionFromOffer,
  ProductSellerVoucherLabel,
} from '../../../../product'
import { useProductPageContext } from '../../productPageContext'

export const ProductHeadSellerPromotionLabel: FC = () => {
  const { currentOffer } = useProductPageContext()
  const sellerPromotion =
    productAccessorGetBestSellerPromotionFromOffer(currentOffer)

  return sellerPromotion ? (
    <span className="mb-2.5 mr-2.5">
      <ProductSellerVoucherLabel sellerPromotion={sellerPromotion} />
    </span>
  ) : null
}
